import React from "react";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { ParticipantTabNavs } from "../../../shared/components/tabNavs";
import Sidebar from "../../Layout/sidebar";
import ClearPageLayout from "@/containers/Participant/components/ClearPageLayout";
import CartPage from "./components/CartPage";
import { useTranslation } from "react-i18next";
import { GcmBrand } from "@/containers/Participant/GcmShared/GcmHeader";
import { hasGcmItems } from "@/containers/Participant/GcmShared/helpers";

const IMG_BACK = `${process.env.PUBLIC_URL}/theme/classic/img/pages/my-points.jpg`;

export const Cart = ({ template, cart }) => {
  const { t } = useTranslation();
  

  const OriginCart = () => {
    return (
      <div className="mp-page">
        <div className="mp-page__header">
          <Container>
            <div className="mp-page__header-inner">
              <div>
                <h1 className="mp-page__title">{t("cart")}</h1>
                <p className="mp-page__desc">{t("review_cart_desc")}</p>
              </div>
              {hasGcmItems(cart?.items) && <GcmBrand className="gcm-brand--inline" />}
            </div>
          </Container>
        </div>

        <Container className="mp-page__body">
          <ClearPageLayout>
            <CartPage />
          </ClearPageLayout>
        </Container>
      </div>
    );
  };

  const NewCart = () => {
    return (
      <>
        <div className="mainboard">
          <img src={IMG_BACK} alt="point_img" />
          <div className="title">{t("redeem_my_points")}</div>
        </div>
        <Container>
          <ParticipantTabNavs />
        </Container>
        <Container>
          <Row>
            <Col md={9}>
              <div className="dashboard">
                <CartPage />
              </div>
            </Col>
            <Col md={3}>
              <Sidebar />
            </Col>
          </Row>
        </Container>
      </>
    );
  };

  return (
    (template?.name === "clear" && <OriginCart />) ||
    (template?.name === "classic" && <NewCart />)
  );
};

const mapStateToProps = (state) => {
  return {
    template: state.template,
    cart: state.cart,
  };
};

export default connect(mapStateToProps)(Cart);
